import { AdminPages } from '../AdminPages';
import { SORT_ASC } from '../../../utilities/FormUtilities';
import {
    DELETE,
    DISABLE,
    ENABLE,
    SCHEDULE,
    SERVICE_TESTS_API_BASE,
    TESTS_DETAIL_UPDATE_ENDPOINT,
    TESTS_LIST_UPDATE_ENDPOINT,
} from '../../../services/FormDataTableActionService';

export const TEST_TYPES_API = '/ipm/v1/open/testTypes';

export const SERVICE_TESTS_FUNCTION_NAME = AdminPages.ServiceTests;
export const SERVICE_TESTS_LIST_FUNCTION_NAME = 'service-tests-list';
export const SERVICE_TESTS_DETAIL_FUNCTION_NAME = 'service-tests-detail';
export const DETAILS_TITLE = 'details.title';
export const BREADCRUMB_TEXT_SUFFIX = ' Tests';
export const PARENT_TITLE = 'Service Tests';

export const NEW_STATE = 'new';
export const DUPLICATE_OF = 'dupOf';

export const TYPE_WEB = 'Web';
export const TYPE_VOIP = 'VoIP';
export const Unknown = 'Unknown';
// Field names (matching backend schema)
export const TEST_NAME_FIELD = 'name';
export const TEST_DESCRIPTION_FIELD = 'details.description';

export const TEST_TYPE_FIELD = 'type';
export const TEST_STATUS_FIELD = 'status';
export const TEST_TAGS_FIELD = 'tags';
export const TEST_BUSINESS_SERVICES_FIELD = 'businessServices';
export const TEST_BUSINESS_SERVICES_NAME = 'businessServices.name';
export const TEST_CONFIG_FIELD = 'testConfig';
export const TEST_CONFIG_TARGET_FIELD = 'testConfig.target';
export const TEST_CONFIG_URL_FIELD = 'testConfig.url';

export const ALL_MODE = 'all';
export const SELECTED_MODE = 'selected';
export const TAGGED_MODE = 'tagged';

// RHF field name for the agents object (e.g. 'agents')
export const AGENT_FIELD_NAME = 'agents';
export const AGENT_TAGS_FIELD_NAME = 'agents.tags';
export const AGENT_IDS_FIELD_NAME = 'agents.ids';
export const AGENT_ALL_FIELD_NAME = 'agents.all';
export const AGENT_MATCHALLTAGS_FIELD_NAME = 'agents.matchAllTags';

export const TESTCONFIG_CALLVIA_FIELD_NAME = 'testConfig.callVia';
export const TESTCONFIG_CALLER_FIELD_NAME = 'testConfig.caller';
export const TESTCONFIG_CALLEE_FIELD_NAME = 'testConfig.callee';

export const ADAPTER_TYPE_FIELD_NAME = 'adapterType';
export const SCHEDULING_FIELD_NAME = 'scheduling';

export const WIRELESS = 'wireless';
export const DEFAULT = 'default';
export const MULTI = 'multi';
export const TAG_AND = 'AND';
export const TAG_OR = 'OR';

export const NAME_ASC_SORT_FIELD_INFO = [
    {
        property: TEST_NAME_FIELD,
        direction: SORT_ASC,
    },
];

export const SERVICE_TESTS_DATA_SOURCE = {
    url: SERVICE_TESTS_API_BASE,
    crudUrl: TESTS_LIST_UPDATE_ENDPOINT,
    totalProperty: 'count',
    dataProperty: 'data',
    params: {
        entityFields: [
            TEST_NAME_FIELD,
            TEST_STATUS_FIELD,
            TEST_TAGS_FIELD,
            TEST_BUSINESS_SERVICES_NAME,
            TEST_CONFIG_URL_FIELD,
        ],
    },
};

export const SERVICE_TESTS_LIST_ACTION_URLS = {
    [ENABLE]: TESTS_LIST_UPDATE_ENDPOINT,
    [DISABLE]: TESTS_LIST_UPDATE_ENDPOINT,
    [DELETE]: SERVICE_TESTS_API_BASE,
    [SCHEDULE]: TESTS_LIST_UPDATE_ENDPOINT,
};

export const SERVICE_TESTS_DETAIL_ACTION_URLS = {
    [ENABLE]: TESTS_DETAIL_UPDATE_ENDPOINT,
    [DISABLE]: TESTS_DETAIL_UPDATE_ENDPOINT,
    [DELETE]: TESTS_DETAIL_UPDATE_ENDPOINT,
};

// VoIP domain constants
export const VOIP_ADAPTER_TYPE_WIRELESS = WIRELESS;
export const VOIP_ADAPTER_TYPE_DEFAULT = DEFAULT;
export const VOIP_IP_VERSION_IPV4 = 'ipv4';
export const VOIP_IP_VERSION_IPV6 = 'ipv6';
export const VOIP_ICON_PREFIX = 'ipm-';
export const VOIP_AGENTS_CONTEXT_NAME = 'VoipAgents';

export const WIFI_TEST_TYPES = new Set(['wifi', 'wifiConnect', 'wiFiMultiBssidConnection', 'wifiConnectMultiTest']);

export const TEST_TYPE_NAME_PARAM = 'name';

/**
 * Maps test type names to user-facing display titles.
 * Source: portal/ui i18next keys config.templates.testTitle.{name}
 * with general.pulse = "nPoint" interpolation.
 */
const TEST_TYPE_DISPLAY_TITLES = {
    VoipPulse: 'VoIP nPoint to nPoint',
    VoipPhone: 'VoIP nPoint to Phone',
};

/**
 * Returns the user-facing display title for a test type.
 * Falls back to details.title, then testType.name, then empty string.
 * @param {Object} testType - The test type object from API
 * @returns {string} Display title
 */
export const getTestTypeDisplayTitle = (testType) => {
    return TEST_TYPE_DISPLAY_TITLES[testType?.name] || testType?.details?.title || testType?.name || '';
};
